import type { Nullable } from 'corgi-types';

import type { Reason } from '../components/types';
import { LEGAL_CONCERNS_REASON } from '../constants';

export const getReasonFromReasonList = (
  reasons: Array<Nullable<Reason>>,
  reasonId: Nullable<string>
): Nullable<Reason> => {
  const foundReason = reasons.find(reason => reason?.id === reasonId);

  if (foundReason) {
    return foundReason;
  }

  for (const reason of reasons) {
    if (reason) {
      const foundSubreason = getReasonFromReasonList(reason.values ?? [], reasonId);

      if (foundSubreason) return foundSubreason;
    }
  }

  return null;
};

export const reasonContainsSubreasons = (reason: Nullable<Reason>) =>
  reason?.values?.length ?? 0 > 0;

export const isReasonLegalConcern = (reason: string) => reason.startsWith(LEGAL_CONCERNS_REASON);
